import { useEffect, useState } from 'react';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaKind } from '~/ui/video-player/MediaPlayerStore';
import { MediaSource, mediaSourcesMatch } from '~/ui/video-player/mediaSource';
import { useSequenceStore } from './SequenceStore';

/** A mounted requirement owns its registration; accepted credit belongs to its source. */
export function useMediaBlocker(
  id: string,
  blocking: boolean,
  source: MediaSource | null | undefined,
  kind: MediaKind
) {
  const [owner] = useState(() => Symbol('media-blocker'));
  const status = useMediaPlayerStore(s => s.status);
  const completed = useMediaPlayerStore(s => s.completed);
  const mediaSrc = useMediaPlayerStore(s => s.mediaSrc);
  const mediaKind = useMediaPlayerStore(s => s.mediaKind);
  const addBlocker = useSequenceStore(s => s.addBlocker);
  const removeBlocker = useSequenceStore(s => s.removeBlocker);
  const ownsSource =
    mediaKind === kind && mediaSourcesMatch(mediaSrc, source ?? '');
  const accepted = ownsSource && (completed || status === 'done');
  const hasSource = Array.isArray(source) ? source.length > 0 : Boolean(source);
  const unavailable = !hasSource || (ownsSource && status === 'nomedia');

  useEffect(() => {
    if (blocking && !accepted && !unavailable) addBlocker(id, owner);
    else removeBlocker(id, owner);
    return () => removeBlocker(id, owner);
  }, [id, blocking, accepted, unavailable, owner, addBlocker, removeBlocker]);

  return accepted;
}
